import type { MetricRate, SentinelAnalyticsSeriesPoint } from '@/types/sentinelAnalytics';
import { BigNumber } from './big-number';
import { formatCardPercent, formatFraction } from './format';
import { MetricCardFrame } from '@/modules/analytics-v2/components/metric-card';
import { TrendChart } from './trend-chart';

interface RateCardProps {
  title: string;
  help: string;
  metric: MetricRate;
  /** Noun after the fraction, e.g. "tickets"; '' shows the bare fraction, leave out to hide it, as some Figma cards do. */
  unit?: string;
  /** Breakdown lines under the help text; only AI Generation Failure has them (one per failure reason). */
  details?: string[];
  trend?: { series: SentinelAnalyticsSeriesPoint[]; value: (point: SentinelAnalyticsSeriesPoint) => number | null };
  suffix?: string;
}

export function RateCard({ title, help, metric, unit, details, trend, suffix }: RateCardProps) {
  return (
    <MetricCardFrame title={title} help={help} details={details}>
      <BigNumber value={formatCardPercent(metric.rate)} suffix={suffix} detail={unit === undefined ? undefined : `${formatFraction(metric)} ${unit}`.trim()} />
      {trend ? <TrendChart series={trend.series} value={trend.value} unit='percent' label={title} /> : null}
    </MetricCardFrame>
  );
}
